export default __webpack_public_path__ + "static/media/metamask.a8bd5773.svg";